import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { BetCalculationsEnum } from 'src/constants/enums/betCalculations';
import { useTranslation } from "src/hooks/translation";
import selectionsStore from 'src/stores/selections';
import upperDataStore from 'src/stores/upperData';
import { getBetCalculations } from 'calculation';
import Money from 'src/common/components/money';
import { useConfig } from 'src/hooks/config';
import mainStore from 'src/stores/main';

interface IProps {
  stake: number;
}

const BetDetailsEstimatedReturn = ({ stake }: IProps) => {
  const t = useTranslation();
  const config = useConfig();
  const { betType, systemCombinationCount, profitBoostPercent, isProfitBoost } = useRecoilValue(mainStore);
  const { selections } = useRecoilValue(selectionsStore);
  const { partnerConfig, bonusRules, currencyConfig } = useRecoilValue(upperDataStore);

  const filtredBonusRules = bonusRules.filter(item => !item.ExactLosing);

  const { estimatedReturn } = useMemo(() => getBetCalculations([
    BetCalculationsEnum.EstimatedReturn,
  ], {
    config,
    betType,
    partnerConfig,
    stake: +stake,
    events: selections,
    bonusRule: filtredBonusRules,
    systemCombinationCount,
    currencyConfig,
  }), [config, partnerConfig, stake, currencyConfig, selections, betType, filtredBonusRules, systemCombinationCount]);

  const { possibleWin } = useMemo(() => (
    getBetCalculations([
      BetCalculationsEnum.PossibleWin,
    ], {
      config,
      partnerConfig,
      betType,
      stake: +stake,
      events: selections,
      systemCombinationCount,
      currencyConfig,
    })
  ), [config, partnerConfig, currencyConfig, stake, betType, selections, systemCombinationCount]);

  const profitBoost = profitBoostPercent && ((possibleWin - stake) * profitBoostPercent) / 100;

  if (!estimatedReturn) return null;

  const estimateReturnAmount = profitBoost && isProfitBoost ? estimatedReturn + profitBoost : estimatedReturn;

  return (
    <div className="B-betslip-bet-details-info-row">
      <p className="B-info-row-title">{t('Estimated Return')}</p>
      <p className="B-info-row-number">
        <Money amount={estimateReturnAmount} />
      </p>
    </div>
  );
};

export default BetDetailsEstimatedReturn;
